<template>
  <v-app-bar :color="navBarBg" app density="compact" :elevation="3" fixed>
    <v-avatar size="40" class="mx-3">
      <v-img src="logo.png" @click.prevent="showDrawer"> </v-img>
    </v-avatar>
    <v-app-bar-title class="app-bar-title" :style="{ color: navBarText }">{{ getPageTitle }}</v-app-bar-title>
    <v-btn
      v-if="currentPageId > 0"
      flat
      :color="navBarBg"
      class="mr-1 text-none"
      :style="{ color: navBarText }"
      size="small"
      icon="fa-solid fa-palette"
      title="Personalizar Tema"
      @click="showThemeDrawer()"
    >
    </v-btn>
    <v-btn
      v-if="itemsOnCart > 0"
      flat
      :color="navBarBg"
      class="mr-3 text-none"
      :style="{ color: navBarText }"
      stacked
      size="xs"
      to="/salesorder"
    >
      <v-badge :content="itemsOnCart" color="grey-lighten-1">
        <v-icon :style="{ color: navBarText }">fa-solid fa-cart-shopping</v-icon>
      </v-badge>
    </v-btn>
  </v-app-bar>

  <ThemeDrawer
    v-model="themeDrawer"
    @toast="showToast"
  />

  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    timeout="3000"
    location="bottom right"
  >
    {{ snackbarText }}
    <template v-slot:actions>
      <v-btn variant="text" size="small" @click="snackbar = false">Cerrar</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import ThemeDrawer from './ThemeDrawer.vue';

export default {
  components: {
    ThemeDrawer,
  },
  data() {
    return {
      themeDrawer: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
    };
  },
  methods: {
    showThemeDrawer() {
      if(this.userIsGuest) {
        this.showToast('Debe iniciar sesión para personalizar el tema', 'error');
        return;
      }
      if(this.$store.getters.pageId > 0) {
        this.themeDrawer = true;
      }
    },
    showDrawer() {
      this.$store.dispatch("toggleShowDrawer");
    },
    showToast(message, color = 'success') {
      this.snackbarText = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
  computed: {
    getPageTitle() {
      return this.$store.getters.pageTitle;
    },
    itemsOnCart() {
      return this.$store.getters.itemsOnCart;
    },
    navBarBg() {
      return this.$store.getters["theme/navBarBg"];
    },
    navBarText() {
      return this.$store.getters["theme/navBarText"];
    },
    currentPageId() {
      return this.$store.getters.pageId;
    },
  },
};
</script>

<style scoped>
.image {
  border: 1px;
  mix-blend-mode: multiply;
}

.app-bar-title {
  color: var(--rhinos-nav-text, black);
}
</style>
